import firebase from "firebase";
const db = firebase.database();

export function fetchPrivacyPolicy(coachOrgId) {
  return new Promise(async (resolve, reject) => {
    try {
      const path = `privacyPolicy/${coachOrgId}`;
      const result = await db
        .ref(path)
        .once("value")
        .then((s) => s.val());
      resolve(result);
    } catch (e) {
      reject(e);
    }
  });
}



// WEBPACK FOOTER //
// ./src/domains/PrivacyDomain.js